import { IOrder } from '../../../../../../../../app/entities/Order'
import { OrderService } from '../../../../../../../../app/entities/OrderService'
import {
  GENERIC_SERVICE,
  ACTIVE_SERVICES,
  SERVICE_NAMES,
} from '../../../../../../global/constants/service'
import {
  getInitialStateProps,
  ISchedulerStateProps,
} from '../../../../../../schedule/components/schedule-modal/components/container-modal/initialData'

/**
 * This function exists out of necessity because of how we have always managed the frontend
 * It creates the scheduler state from an order object
 * One day it would be nice to get rid of the scheduler state and just use the order object directly
 * @param orderData
 * @returns ISchedulerStateProps
 */
export default function transformOrderIntoSchedulerState(
  orderData: IOrder,
): ISchedulerStateProps {
  const newSchedulerState: ISchedulerStateProps = getInitialStateProps()

  //prettier-ignore
  const { installationPoint, customer, orderVehicles, orderServices, freeOrderReason, objectId, status } = orderData

  newSchedulerState.orderId = objectId
  newSchedulerState.status = status ?? ''

  //prettier-ignore
  if (installationPoint) {
    newSchedulerState.customerInformation.address = installationPoint.address
    newSchedulerState.customerInformation.zipCode = installationPoint.zipCode
    newSchedulerState.customerInformation.city = installationPoint.city
    newSchedulerState.customerInformation.state = installationPoint.state
    newSchedulerState.customerInformation.additionalInformation = installationPoint.additionalInformation
    newSchedulerState.customerInformation.installationPointObjectId = installationPoint.objectId
  }

  if (orderServices) {
    orderServices.forEach((orderService: OrderService) => {
      const isProduct = orderService.service?.isProduct
      const isGenericService = GENERIC_SERVICE.includes(orderService.label)
      if (orderService.label === SERVICE_NAMES.TIRE_DISPOSAL) {
        newSchedulerState.tireDisposal = true
        newSchedulerState.disposalQty = orderService.quantity
      } else if (orderService.label === SERVICE_NAMES.STATE_TIRE_FEE) {
        newSchedulerState.stateTireFee = orderService
      } else if (isProduct || isGenericService) {
        if (!newSchedulerState.genericItems) {
          newSchedulerState.genericItems = []
        }
        newSchedulerState.genericItems.push(orderService)
      } else if (ACTIVE_SERVICES.includes(orderService.label)) {
        newSchedulerState.orderService = orderService.objectId
        newSchedulerState.service = orderService.service?.objectId || ''
        if (!orderService.priceOverride) {
          newSchedulerState.servicePriceOverride = orderService.priceOverride
        }
      }
    })
  }

  //prettier-ignore
  if (freeOrderReason) {
    newSchedulerState.freeOrderReason.objectId = freeOrderReason.objectId
    newSchedulerState.freeOrderReason.reason = freeOrderReason.reason
    newSchedulerState.freeOrderReason.isFree = true
  }

  //prettier-ignore
  if (customer) {
    newSchedulerState.customerId = customer.objectId
    newSchedulerState.customerInformation.firstName = customer.firstName
    newSchedulerState.customerInformation.lastName = customer.lastName
    newSchedulerState.customerInformation.email = customer.email
    newSchedulerState.customerInformation.phone = customer.phoneNumber
  }

  if (orderVehicles) {
    orderVehicles.forEach((ov) => {
      const { customerVehicle, tiresCombination } = ov

      newSchedulerState.orderVehicleId = ov.objectId

      if (customerVehicle) {
        newSchedulerState.customerInformation.mileage = ov.mileage
        newSchedulerState.customerVehicleId = customerVehicle.objectId
        newSchedulerState.customerInformation.brandName =
          customerVehicle.brand?.name ?? ''
        newSchedulerState.customerInformation.model = customerVehicle.model
        newSchedulerState.customerInformation.year = customerVehicle.year
        newSchedulerState.customerInformation.variant = customerVehicle.variant
        newSchedulerState.customerInformation.brandId =
          customerVehicle.brand?.objectId ?? ''
      }
      if (tiresCombination) {
        newSchedulerState.tiresCombination = tiresCombination
      }
    })
  }
  return newSchedulerState
}
